import * as React from "react";

const LinkGarbageHover: React.FC = () => {
    return (
        <svg
            width="11px"
            height="13px"
            viewBox="0 0 11 13"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
        </svg>
    );
};

export default React.memo(LinkGarbageHover);


